import { Routes } from '@angular/router';
// Third party packages
// Custom packages - Misc
import { RoleGuard } from 'src/app/shared/guards/role.guard';
// Custom packages - Component
import { CommunicationsListComponent } from 'src/app/modules/communications/pages/communications-list/communications-list.page';
var ɵ0 = {
    communications: ['canReadCommunicationsList']
};
var routes = [
    {
        path: 'list',
        component: CommunicationsListComponent,
        canActivate: [RoleGuard],
        data: ɵ0,
    },
    {
        path: '**',
        redirectTo: 'it/errors/404'
    }
];
var CommunicationsRoutingModule = /** @class */ (function () {
    function CommunicationsRoutingModule() {
    }
    return CommunicationsRoutingModule;
}());
export { CommunicationsRoutingModule };
export { ɵ0 };
